<template>
  <div>
    <el-row style="margin: 12px 0;align-items: center;">
      <el-col :span="12" class="propsLeft">{{ label }}</el-col>
    </el-row>
    <el-row style="margin: 12px 0;">
      <el-radio-group v-model="radio" @change="onChange" size="mini">
        <el-radio-button :label="option.name" v-for="option in options" :key="option.name"></el-radio-button>
      </el-radio-group>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: Number,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    size: {
      type: String,
      required: true
    }
  },
  computed: {
  },
  data () {
    return {
      radio: ''
    }
  },
  methods: {
    onChange (val) {
      this.$emit('change', {
        id: this.id,
        valueProp: 'size',
        value: val
      })
    }
  },
  watch: {
    'size' (val) {
      this.radio = val
    }
  },
  mounted () {
    this.radio = this.size
  }
}
</script>

<style lang="scss" coped>
</style>
